import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import {
  HistoricalInstitutionalVsNonFilersInstitutionsApiModel,
  HistoricalInstitutionalVsNonFilersInstitutionsModel
} from './historical-institutional-vs-non-filers-institutions.model';

export class HistoricalInstitutionalVsNonFilersInstitutionsConfiguration extends ReportSectionConfigurationBase {
  typeName = 'HistoricalInstitutionalVsNonFilersInstitutionsConfiguration';
  nodataLocalizationKeyName = 'historicalInstitutionalVsNonFilersInstitutions';
  readonly reportSection = ReportSection.HistoricalInstitutionalVsNonFilersInstitutions;
  readonly applicableReportTypes = [ReportType.OwnershipAnalyticsReport];
  readonly reportViewModelSections = [
    ReportViewModelSection.OwnershipAnalyticsReport_HistoricalVsNonFilersInstitutions
  ];
  readonly minSize = 2;
  readonly maxSize = 4;
  readonly defaultSize = 4;
  readonly availableDataSections = [];

  get name(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'historicalInstitutionalVsNonFilersInstitutions';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'Historical Institutional vs Non-Filers Ownership';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface HistoricalInstitutionalVsNonFilersInstitutionsData {
  [ReportViewModelSection.OwnershipAnalyticsReport_HistoricalVsNonFilersInstitutions]:
    | HistoricalInstitutionalVsNonFilersInstitutionsModel
    | HistoricalInstitutionalVsNonFilersInstitutionsApiModel;
}
